import { render, staticRenderFns } from "./BadgesCreated.vue?vue&type=template&id=7e02a4d9"
import script from "./BadgesCreated.vue?vue&type=script&lang=js"
export * from "./BadgesCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports